import React, { useEffect, useState, useRef, useContext } from 'react'
import axios from 'axios'
import CertificatesContext from '../../../../../../contexts/CertificatesContext'
import { HeatNumberOptionDiv, HeatNumberOptionText, HeatNumbersDropdownContainer } from './style'

interface ParamsType {
  quantity: number
  certificateTypeId: number
}

interface propsType {
  open: React.Dispatch<React.SetStateAction<boolean>>
}

const HeatNumbersDropdown: React.FC<propsType> = (props) => {
  const { setCertificate, certificate } = useContext(CertificatesContext)
  const [ heatNumbers, setHeatNumbers ] = useState<{ id: number, heatNumber: string, certificates:any[] }[]>([])
  const typeId = certificate.type.id
  const [ paramsToBack, setParamsToBack ] = useState<ParamsType>({ quantity: 30, certificateTypeId: typeId })

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BASE_URL}/heat-number`, { params: paramsToBack })
      .then(response => {
        setHeatNumbers(response.data)
      })
      .catch(error => {
        console.error(error)
      })
  }, [paramsToBack])

  const dropdownRef = useRef<HTMLDivElement | null>(null)

  const handleScroll = () => {
    if (dropdownRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = dropdownRef.current
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        setParamsToBack(prevParams => ({
          ...prevParams,
          quantity: prevParams.quantity + 30
        }))
      }
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      props.open(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleSetHeatNumberInCertificate = (item: { heatNumber: string, id: number}) => {
    setCertificate(prev => ({
      ...prev,
      heatNumber: item
    }))
    props.open(false)
  }

  return (
    <HeatNumbersDropdownContainer ref={dropdownRef} onScroll={handleScroll}>
      {heatNumbers.map((item: any, index) => (
        <HeatNumberOptionDiv key={index} onClick={() => handleSetHeatNumberInCertificate(item)}>
          <HeatNumberOptionText>
            {item.heatNumber}
          </HeatNumberOptionText>
        </HeatNumberOptionDiv>
      ))}
    </HeatNumbersDropdownContainer>
  )
}

export default HeatNumbersDropdown